export default {
  byId: 'PLANNING_GETTERS_BY_ID',
  byCultivation: 'PLANNING_GETTERS_BY_CULTIVATION',
  isSomePastDataLoaded: 'PLANNING_GETTERS_IS_SOME_PAST_DATA_LOADED',
  isAllDataLoaded: 'PLANNING_GETTERS_IS_ALL_DATA_LOADED',
  cultivations: 'PLANNING_GETTERS_CULTIVATIONS',
  all: 'PLANNING_GETTERS_ALL',
  past: 'PLANNING_GETTERS_PAST',
  forgotten: 'PLANNING_GETTERS_FORGOTTEN',
  coming: 'PLANNING_GETTERS_COMING',
  comingWeek: 'PLANNING_GETTERS_COMING_WEEK',
  forDate: 'CROPS_GETTERS_FOR_DATE'
}
